import type { NodeData } from "./data";

export interface ComplaintNode {
  id: string;
  name: string;
  path: string[];
}

const flattenedTreeCache = new WeakMap<NodeData[], ComplaintNode[]>();

export const flattenComplaintCodeTree = (nodes: NodeData[], path: string[] = []) => {
  // Only cache root calls because subtree paths depend on their ancestors.
  if (path.length === 0) {
    const cached = flattenedTreeCache.get(nodes);
    if (cached) return cached;
  }

  const flat = nodes.reduce<ComplaintNode[]>((acc, node) => {
    const currentPath = [...path, node.name];
    acc.push({ id: node.id, name: node.name, path: currentPath });
    if (node.children) {
      acc.push(...flattenComplaintCodeTree(node.children, currentPath));
    }
    return acc;
  }, []);

  if (path.length === 0) flattenedTreeCache.set(nodes, flat);
  return flat;
};

export const matchComplaintNode = (name: string, path: string, searchTerm: string) => {
  if (!searchTerm) return true;
  const nPath = path.split("/").map(n => n?.toLowerCase()).filter(Boolean);
  const words = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
  // match if all words are found in either the name or the path
  // this is way better UX as it allows for partial matches in any order and generally describing what their looking for
  return words.every(word => name.toLowerCase().includes(word) || nPath.some(p => p.includes(word)));
};
